<!-- Whitepaper Hero Section (No Changes Here) -->
<div class="annual-hero-bg">
  <section class="annual-hero-section container">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-5 hero-content-col">
          <h1 class="banner-heading-one">Kalpita Whitepaper</h1>
        </div>
        <div class="col-lg-7 hero-image-col">
          <img src="../../../../assets/resources/whitepaper/whitepaper-bannerimage.png"
            alt="Annual Reports Illustration" class="hero-image">
        </div>
      </div>
    </div>
  </section>
</div>
<!-- Whitepaper List Section -->
<div class="whitepapers-list-section">
  <div class="container">
    <h2 class="section-title">Know About Our Whitepapers</h2>

    <div class="row g-4">
      <!-- Loop through the whitePapers array -->
      <div class="col-lg-4 col-md-6" *ngFor="let wp of whitePapers">
        <!-- New Card Structure with Animation Attribute -->
        <div class="whitepaper-card" (click)="nav(wp.route)" data-aos="fade-up">
          <img [src]="wp.img" [alt]="wp.title" class="card-image">
          <div class="card-content">
            <h6 class="card-title">{{ wp.title }}</h6>
            <div class="arrow-icon-wrapper">
              <i class="ri-arrow-right-line"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>